module.exports = __webpack_public_path__ + "img/hidden.748e9917.svg";